module.exports = __webpack_public_path__ + "static/media/ubiq.29b096e1.png";